import styled from "styled-components";

export const ArticleDetailBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100rem;
  margin: 0 auto;
  padding-top: 4rem;
`;
